import React from "react";
import {CheckOutlined} from "@ant-design/icons";
import {Button, Image, Space} from "antd";
import moment from "moment";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import styles from './styles.module.less';

type TCertPaper = {
  url: string | null;
  time: number | null;
  version?: number | null; // 证书图片缓存版本（随证书更新变化，绕过同名覆盖的浏览器缓存）
  onSubmit:() => void;
}

const CertPaper:React.FC<TCertPaper> = ({time,onSubmit,url,version}) => {
  const imgSrc = url ? `${url}${url.includes('?') ? '&' : '?'}v=${version ?? ''}` : null;
  return (
    <div className={styles.cert_paper_wrapper}>
      <PcComponentWrapper>
        <div className={styles.row}>
          <Space size={16}>
            <div className={styles.icon}>
              <CheckOutlined />
            </div>
            <div>
              <p className={styles.title}>查询到证书</p>
              {time && (
                <p className={styles.subtitle}>证书获得时间：{moment(time).format('YYYY-MM-DD HH:mm:ss')}</p>
              )}
            </div>
          </Space>
          <Button className={styles.btn} onClick={onSubmit}>继续查询</Button>
        </div>
      </PcComponentWrapper>
      <MobileComponentWrapper>
        <div className={styles.row}>
          <div>
            <div className={styles.icon_wrapper}>
              <div className={styles.icon}>
                <CheckOutlined />
              </div>
            </div>
            <div>
              <p className={styles.title}>查询到证书</p>
              <p className={styles.subtitle}>证书获得时间：2123</p>
            </div>
          </div>
        </div>
      </MobileComponentWrapper>
      {imgSrc && (
        <div className={styles.img_area}>
          <Image className={styles.img} src={imgSrc} />
        </div>
      )}
      <MobileComponentWrapper>
        <Button className={styles.btn} onClick={onSubmit}>继续查询</Button>
      </MobileComponentWrapper>
    </div>
  )
}
export default CertPaper;
